import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';
import Slider from 'react-slick';

export const StyledFeatureInfoCardsSection = styled.section`
  background: linear-gradient(180deg, #ffffff 0%, #f1d4e2 50%, #b7b6fe 100%);
  padding: 8rem 1rem;
  margin: 0 auto;
  text-align: center;

  .container {
    max-width: 1250px;
  }

  .header {
    margin-bottom: 3rem;

    & h2 {
      font-family: Geomanist;
      color: var(--color-primary);
      font-weight: 500;
      font-size: 30px;
      line-height: 35px;
      text-align: center;
      margin-bottom: 1.5rem;

      @media ${breakpoints.tablet} {
        font-size: 36px;
      }

      @media ${breakpoints.desktop} {
        font-size: 54px;
        line-height: 100%;
      }
    }

    & p {
      font-family: Roboto;
      font-weight: 200;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      color: var(--color-black);
      margin-bottom: 1.5rem;

      & strong {
        font-weight: 700;
      }

      @media ${breakpoints.desktop} {
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
`;

export const CardsWrapper = styled.div`
  display: grid;
  gap: 3rem;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  text-align: left;

  @media ${breakpoints.desktopLarge} {
    display: flex;
    justify-content: space-around;
  }
`;

export const StyledCard = styled.div`
  background-color: #ffffff;
  padding: 2rem;
  border-radius: 1.5rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 315px;

  .image-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    height: 145px;
  }

  .card-title {
    color: var(--color-primary);
    font-family: Geomanist;
    font-weight: 500;
    font-size: 26px;
    line-height: 28px;
    margin-top: 0.5rem;

    @media ${breakpoints.tablet} {
      font-size: 18px;
      line-height: 20px;
    }

    @media ${breakpoints.desktop} {
      font-size: 26px;
      line-height: 28px;
    }
  }

  .card-description {
    & p {
      color: var(--color-black);
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      margin-top: 1.5rem;

      @media ${breakpoints.tablet} {
        font-size: 14px;
        line-height: 20px;
      }

      @media ${breakpoints.desktop} {
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
`;

export const StyledSlider = styled(Slider)`
  position: relative;

  .slick-slide {
    padding: 0 1rem;
  }

  .slick-dots {
    display: flex !important;
    justify-content: center;
    margin-top: 2rem;
    gap: 0.5rem;

    li {
      width: 9px;
      height: 9px;
      margin: 0;

      button {
        width: 100%;
        height: 100%;
        padding: 0;

        &:before {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background-color: #ccc;
          opacity: 1;
        }
      }

      &.slick-active button:before {
        background-color: var(--color-primary);
      }
    }
  }
`;
